/*
    Image 500*500
    ImageThumb 100*100
    LinkImage 470*235
    LinkImageThumb 60*60
    VideoImage 470*250
    VideoImageThumb 340*170
 */

module.exports = {
  calculate: calculateSize,
  image: imageSize,
  imageThumb: imageThumbSize,
  linkImage: linkImageSize,
  linkImageThumb: linkImageThumbSize,
  localImage: localImageSize,
  videoImage: videoImageSize,
  videoImageThumb: videoImageThumbSize
};

function calculateSize(srcWidth, srcHeight, maxWidth, maxHeight) {
  var ratio = 0,
    width = srcWidth,
    height = srcHeight;

  if (srcWidth >= srcHeight) {
    // Wide image
    if (srcWidth >= maxWidth) {
      ratio = maxWidth / srcWidth;
      width = maxWidth;
      height = Math.floor(srcHeight * ratio);
      if (height >= maxHeight) {
        ratio = maxHeight / height;
        height = maxHeight;
        width = Math.floor(width * ratio);
      }
    } else if (srcHeight > maxHeight) {
      ratio = maxHeight / srcHeight;
      height = maxHeight;
      width = Math.floor(srcWidth * ratio);
      if (width > maxWidth) {
        ratio = maxWidth / width;
        width = maxWidth;
        height = Math.floor(height * ratio);
      }
    }
  } else if (srcWidth < srcHeight) {
    // Tall image
    if (srcHeight > maxHeight) {
      ratio = maxHeight / srcHeight;
      height = maxHeight;
      width = Math.floor(srcWidth * ratio);
      if (width > maxWidth) {
        ratio = maxWidth / width;
        width = maxWidth;
        height = Math.floor(height * ratio);
      }
    } else if (srcWidth >= maxWidth) {
      ratio = maxWidth / srcWidth;
      width = maxWidth;
      height = Math.floor(srcHeight * ratio);
      if (height >= maxHeight) {
        ratio = maxHeight / height;
        height = maxHeight;
        width = Math.floor(width * ratio);
      }
    }
  }

  return {
    width: width,
    height: height
  };
}

function imageSize(width, height) {
  return calculateSize(width, height, 500, 500);
}

function imageThumbSize(width, height) {
  return calculateSize(width, height, 100, 100);
}

function linkImageSize(width, height) {
  return calculateSize(width, height, 470, 235);
}

function linkImageThumbSize(width, height) {
  return calculateSize(width, height, 60, 60);
}

function localImageSize(rawImage) {
  var promise = new Promise(function(resolve, reject) {
    var tempImage = new Image();

    tempImage.onload = function() {
      resolve({
        height: this.height || 0,
        width: this.width || 0
      });
    };
    tempImage.onerror = reject;

    tempImage.src = rawImage;
  });

  return promise;
}

function videoImageSize(width, height) {
  return calculateSize(width, height, 470, 250);
}

function videoImageThumbSize(width, height) {
  return calculateSize(width, height, 340, 170);
}
